import { camelize } from './strings';
import { getSlugs } from './url';
import {
    ORIGINAL_ITEMS,
    SUGGESTED_ITEMS
} from 'Constants/items';
import { isEmpty } from 'Helpers/objects';

/** Context should have config, location and cookies
 * @param {Object} props: { params, location, }
 * @param {Object} context - { config: { get: }, cookies: { get } }
 */

const parsePathname = pathname => {
    let location = {};

    if (pathname) {
        const [firstSlug] = getSlugs(pathname);

        if (firstSlug && firstSlug.includes('_g')) {
            const [slug, id] = firstSlug.split('_g');
            const name = camelize(slug.split('-').join(' '));

            location = {
                id,
                name
            };
        }
    }

    return location;
};

const routerParamsToSeoQuery = ({
    location: { query: { filter } = {}},
    params: { categoryID, geoID, text, centreName } = {},
    seoInformation
}) => {
    const seoQuery = {};

    if (categoryID) {
        seoQuery.categoryId = categoryID;
    }

    if (geoID) {
        seoQuery.locationId = geoID;
    }

    if (text) {
        seoQuery.query = text;
    }

    if (centreName) {
        seoQuery.locationName = centreName;
    }

    if (filter) {
        seoQuery.filter = filter;
    }

    const { seoInfo: { locationId, makeId } = {}} = seoInformation ?? {};

    if (locationId) {
        seoQuery.locationId = locationId;
    }

    if (makeId) {
        seoQuery.makeId = makeId;
    }

    return seoQuery;
};

const routerParamToCategoryQuery = props => {
    const categoryID = props?.params?.categoryID;
    const categoryQuery = {};

    if (categoryID) {
        categoryQuery.categoryId = categoryID;
    }

    return categoryQuery;
};

const getLabelInfo = ({ totalItems, totalSuggestedAds, show_original_items,
    show_suggested_items, original_label, suggested_label, similarAdsCount }) => {
    let labelInfo;

    if (show_original_items || !show_suggested_items || similarAdsCount) {
        labelInfo = {
            itemsLabel: original_label,
            total: similarAdsCount ? 0 : totalItems,
            labelType: ORIGINAL_ITEMS
        };
    }
    else {
        labelInfo = {
            itemsLabel: suggested_label,
            total: totalSuggestedAds,
            labelType: SUGGESTED_ITEMS
        };
    }

    return labelInfo;
};

const checkIfCategoryTreeAvailable = categoryTreeSelected =>
    !!(categoryTreeSelected && categoryTreeSelected.L1 && !isEmpty(categoryTreeSelected.L1));

const itemCollection = (...args) => {
    Object.setPrototypeOf(args, itemCollection.prototype);
    return args;
};

itemCollection.prototype = Object.create(Array.prototype);
itemCollection.prototype.constructor = itemCollection;
itemCollection.prototype.setTotal = total => {
    if (total) {
        itemCollection.prototype.total = total;
        return;
    }
    delete itemCollection.prototype.total;
};
itemCollection.prototype.setTotalSuggestedAds = total => {
    if (total) {
        itemCollection.prototype.totalSuggestedAds = total;
        return;
    }
    delete itemCollection.prototype.totalSuggestedAds;
};
itemCollection.prototype.setCursor = cursor => {
    if (cursor) {
        itemCollection.prototype.cursor = cursor;
        return;
    }
    delete itemCollection.prototype.cursor;
};
itemCollection.prototype.setNextPageUrl = nextPageUrl => {
    if (nextPageUrl) {
        itemCollection.prototype.nextPageUrl = nextPageUrl;
        return;
    }
    delete itemCollection.prototype.nextPageUrl;
};
itemCollection.prototype.setNextSuggestedPageUrl = nextSuggestedPageUrl => {
    if (nextSuggestedPageUrl) {
        itemCollection.prototype.nextSuggestedPageUrl = nextSuggestedPageUrl;
        return;
    }
    delete itemCollection.prototype.nextSuggestedPageUrl;
};

export {
    getLabelInfo,
    parsePathname,
    routerParamsToSeoQuery,
    checkIfCategoryTreeAvailable,
    itemCollection,
    routerParamToCategoryQuery
};
